<template>
  <div>
    <div
      class="justify-content-space-around is-underlined"
      :class="[
        display === 'block' ? 'pl-5 pt-2 is-size-4' : 'is-flex is-size-3 mb-5'
      ]"
    >
      {{ $t('Most Popular FAQs') }}
    </div>
    <div
      v-if="popularQuestions && Object.keys(popularQuestions).length"
      class="is-flex-wrap ma-1 justify-space-between"
      :class="{
        'columns is-flex': display !== 'block',
        columns: screen !== 'mobile'
      }"
    >
      <div
        v-for="(question, index) in popularQuestions"
        :key="index"
        :class="[display === 'block' ? 'pa-3' : 'column is-6']"
        class="is-flex align-center gap-1 card pointer is-content-space-between"
        @click="openQuestionAnswer(question.slug)"
      >
        <div>
          {{ $i18n.locale === 'ne' ? question.title_ne : question.title }}
        </div>
        <div class="is-flex is-flex-direction-column align-center">
          <div>{{ $t('Views') }}:</div>
          <div>{{ question.view_count || 0 }}</div>
        </div>
      </div>
    </div>
    <div v-else class="mb-5">
      <vue-no-data :loading="loading"></vue-no-data>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueNoData from '@/components/Commons/VueNoData'
export default {
  components: {
    VueNoData
  },
  props: {
    display: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      popularQuestions: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  created() {
    this.getMostPopularFaq()
  },
  methods: {
    getMostPopularFaq() {
      this.loading = true
      this.$axios.$get(`api/v1/common/faq/most-popular/`).then(response => {
        this.popularQuestions = response
        this.loading = false
      })
    },
    openQuestionAnswer(slug) {
      this.$router.push(
        this.localePath({
          name: 'faq-detail-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
